// extracted by mini-css-extract-plugin
export default {"section":"styles_section__wCkgp","card":"styles_card__OaHNX","card_content":"styles_card_content__9q1cY","logos":"styles_logos__+juU-","logo":"styles_logo__+rF9H"};